<template>
  <div id="adminWorkplaceGroupsWrapper">
    <router-view v-if="'id' in $attrs"></router-view>

    <template v-else>
      <div class="columns">
        <div class="column">
          <router-link
              class="button is-pulled-right"
              :to="{ name: 'admin.producers.edit', params: { id: null } }">

            {{ $t('admin.producers.newProducer') }}
          </router-link>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <router-link
              v-for="producer in producers"
              :key="producer.id"
              :to="{ name: 'admin.producers.edit', params: { id: producer.id } }"
              tag="div"
              class="card">
            <div class="card-content">
              {{ producer.name }}
            </div>
          </router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminProducers',

  computed: {
    ...mapGetters({
      producers: 'producers/producers'
    })
  },

  created () {
    this.$store.dispatch('producers/loadAll', true)
  }
}
</script>

<style scoped>

</style>
